module.exports = __webpack_public_path__ + "img/boy-from-bottle-2-sk.80e0856.png";